import { styled } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const DisclaimerStack = styled(Stack)(({ theme }) => ({
  margin: theme.spacing(2, "auto"),
  alignItems: "center",
}));

export const DisclaimerText = styled(Typography)(({ theme }) => ({
  ...theme.body,
  fontStyle: "italic",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const StyledInfoIcon = styled(InfoOutlined)(({ theme }) => ({
  color: theme.palette.text.primary,
}));
